export var AccrualReasonType;
(function (AccrualReasonType) {
    AccrualReasonType["Birthday"] = "Birthday";
    AccrualReasonType["ProbationPeriodEnd"] = "ProbationPeriodEnd";
    AccrualReasonType["Custom"] = "Custom";
    AccrualReasonType["WorkExperienceInTheCompany"] = "WorkExperienceInTheCompany";
    AccrualReasonType["Vkontakte"] = "Vkontakte";
    AccrualReasonType["SurveyPass"] = "SurveyPass";
    // Instagram = 'Instagram',
    // Facebook = 'Facebook',
})(AccrualReasonType || (AccrualReasonType = {}));
export var AccrualConditionType;
(function (AccrualConditionType) {
    AccrualConditionType["Subscription"] = "Subscription";
    AccrualConditionType["HashtagPost"] = "HashtagPost";
    AccrualConditionType["Repost"] = "Repost";
    AccrualConditionType["SpecificPostRepost"] = "SpecificPostRepost";
    AccrualConditionType["Mention"] = "Mention";
    AccrualConditionType["Like"] = "Like";
})(AccrualConditionType || (AccrualConditionType = {}));
export var ActivityTypesEnum;
(function (ActivityTypesEnum) {
    ActivityTypesEnum["Manual"] = "Manual";
    ActivityTypesEnum["Automated"] = "Automated";
    ActivityTypesEnum["Moodle"] = "Moodle";
})(ActivityTypesEnum || (ActivityTypesEnum = {}));
export var ActivityStatusEnum;
(function (ActivityStatusEnum) {
    ActivityStatusEnum["Planned"] = "Planned";
    ActivityStatusEnum["InProgress"] = "InProgress";
    ActivityStatusEnum["Archived"] = "Archived";
})(ActivityStatusEnum || (ActivityStatusEnum = {}));
export var SupervisorRequestStatusType;
(function (SupervisorRequestStatusType) {
    SupervisorRequestStatusType["Waiting"] = "Waiting";
    SupervisorRequestStatusType["Approved"] = "Approved";
    SupervisorRequestStatusType["Declined"] = "Declined";
    SupervisorRequestStatusType["Canceled"] = "Canceled";
})(SupervisorRequestStatusType || (SupervisorRequestStatusType = {}));
export var ApprovalChainSteps;
(function (ApprovalChainSteps) {
    ApprovalChainSteps["Manager"] = "Manager";
    ApprovalChainSteps["DirectSupervisor"] = "DirectSupervisor";
})(ApprovalChainSteps || (ApprovalChainSteps = {}));
export var ApprovalChainType;
(function (ApprovalChainType) {
    ApprovalChainType["Sequential"] = "Sequential";
    ApprovalChainType["ParallelAny"] = "ParallelAny";
    ApprovalChainType["ParallelAll"] = "ParallelAll";
})(ApprovalChainType || (ApprovalChainType = {}));
export var EmployeeImportFieldType;
(function (EmployeeImportFieldType) {
    EmployeeImportFieldType["ImportId"] = "ImportId";
    EmployeeImportFieldType["FirstName"] = "FirstName";
    EmployeeImportFieldType["CityId"] = "CityId";
    EmployeeImportFieldType["LastName"] = "LastName";
    EmployeeImportFieldType["PersonnelNumber"] = "PersonnelNumber";
    EmployeeImportFieldType["MiddleName"] = "MiddleName";
    EmployeeImportFieldType["Email"] = "Email";
    EmployeeImportFieldType["Phone"] = "Phone";
    EmployeeImportFieldType["TealBalance"] = "TealBalance";
    EmployeeImportFieldType["BirthDate"] = "BirthDate";
    EmployeeImportFieldType["HireDate"] = "HireDate";
    EmployeeImportFieldType["FireDate"] = "FireDate";
    EmployeeImportFieldType["ProbationPeriodInMonths"] = "ProbationPeriodInMonths";
    EmployeeImportFieldType["TelegramUsername"] = "TelegramUsername";
    EmployeeImportFieldType["Position"] = "Position";
    EmployeeImportFieldType["DepartmentId"] = "DepartmentId";
    EmployeeImportFieldType["EmployeePhoto"] = "EmployeePhoto";
    EmployeeImportFieldType["InstagramUsername"] = "InstagramUsername";
    EmployeeImportFieldType["VkontakteUsername"] = "VkontakteUsername";
    EmployeeImportFieldType["FacebookUsername"] = "FacebookUsername";
    EmployeeImportFieldType["SupervisorImportId"] = "SupervisorImportId";
    EmployeeImportFieldType["PeopleManagerImportId"] = "PeopleManagerImportId";
    EmployeeImportFieldType["PeopleManagerDelegateImportId"] = "PeopleManagerDelegateImportId";
})(EmployeeImportFieldType || (EmployeeImportFieldType = {}));
export var BuildStatusType;
(function (BuildStatusType) {
    BuildStatusType["Scheduled"] = "Scheduled";
    BuildStatusType["InProgress"] = "InProgress";
    BuildStatusType["Completed"] = "Completed";
    BuildStatusType["Error"] = "Error";
})(BuildStatusType || (BuildStatusType = {}));
export var EmployeesFilterFeatureKeyType;
(function (EmployeesFilterFeatureKeyType) {
    EmployeesFilterFeatureKeyType["Tags"] = "Tags";
    EmployeesFilterFeatureKeyType["City"] = "City";
    EmployeesFilterFeatureKeyType["Department"] = "Department";
    EmployeesFilterFeatureKeyType["Status"] = "Status";
    EmployeesFilterFeatureKeyType["BirthDate"] = "BirthDate";
    EmployeesFilterFeatureKeyType["HireDate"] = "HireDate";
    EmployeesFilterFeatureKeyType["Position"] = "Position";
    EmployeesFilterFeatureKeyType["FireDate"] = "FireDate";
    EmployeesFilterFeatureKeyType["ProbationEndDate"] = "ProbationEndDate";
    EmployeesFilterFeatureKeyType["Supervisors"] = "Supervisors";
    EmployeesFilterFeatureKeyType["PeopleManagers"] = "PeopleManagers";
    EmployeesFilterFeatureKeyType["PeopleManagerDelegates"] = "PeopleManagerDelegates";
})(EmployeesFilterFeatureKeyType || (EmployeesFilterFeatureKeyType = {}));
export var CompanyEnabledFeatureKeyType;
(function (CompanyEnabledFeatureKeyType) {
    CompanyEnabledFeatureKeyType["Vkontakte"] = "vkontakte";
    CompanyEnabledFeatureKeyType["Instagram"] = "instagram";
    CompanyEnabledFeatureKeyType["Telegram"] = "telegram";
    CompanyEnabledFeatureKeyType["Facebook"] = "facebook";
    CompanyEnabledFeatureKeyType["Slack"] = "slack";
    CompanyEnabledFeatureKeyType["X"] = "x";
    CompanyEnabledFeatureKeyType["LinkedIn"] = "linkedIn";
    CompanyEnabledFeatureKeyType["cafeteriaBenefits"] = "cafeteriaBenefits";
    CompanyEnabledFeatureKeyType["Achievements"] = "achievements";
    CompanyEnabledFeatureKeyType["MyDevelopment"] = "myDevelopment";
    CompanyEnabledFeatureKeyType["AddressBookHideEmptyFieldsFilter"] = "addressBookHideEmptyFieldsFilter";
    CompanyEnabledFeatureKeyType["AddressBookDisplayEmail"] = "addressBookDisplayEmail";
    CompanyEnabledFeatureKeyType["AddressBookDisplaySocialNetworks"] = "addressBookDisplaySocialNetworks";
    CompanyEnabledFeatureKeyType["AddressBookDisplayPhone"] = "addressBookDisplayPhone";
    CompanyEnabledFeatureKeyType["AddressBookEnableChat"] = "addressBookEnableChat";
    CompanyEnabledFeatureKeyType["EnableChat"] = "addressBookEnableChat";
    CompanyEnabledFeatureKeyType["PostComments"] = "postComments";
    CompanyEnabledFeatureKeyType["UsersSelfRegistrationWithoutPredefinedData"] = "usersSelfRegistrationWithoutPredefinedData";
    CompanyEnabledFeatureKeyType["EditUserSelfProfile"] = "editUserSelfProfile";
    CompanyEnabledFeatureKeyType["AllowEmployeesToThank"] = "allowEmployeesToThank";
    CompanyEnabledFeatureKeyType["AllowSupervisorsToThank"] = "allowSupervisorsToThank";
    CompanyEnabledFeatureKeyType["AllowEmployeesToTransferCurrency"] = "allowEmployeesToTransferCurrency";
    CompanyEnabledFeatureKeyType["AllowSupervisorsToTransferCurrency"] = "allowSupervisorsToTransferCurrency";
    CompanyEnabledFeatureKeyType["PublishWeekLeaders"] = "publishWeekLeaders";
    CompanyEnabledFeatureKeyType["moodleCoursesIntegration"] = "moodleCoursesIntegration";
    CompanyEnabledFeatureKeyType["moodleUsersIntegration"] = "moodleUsersIntegration";
    CompanyEnabledFeatureKeyType["SurpriseBoxes"] = "surpriseBoxes";
    CompanyEnabledFeatureKeyType["OrganizationStructure"] = "organizationStructure";
    CompanyEnabledFeatureKeyType["editUserSelfProfileFIO"] = "editUserSelfProfileFIO";
    CompanyEnabledFeatureKeyType["editFIOEvenIfImportEnabled"] = "editFIOEvenIfImportEnabled";
    CompanyEnabledFeatureKeyType["managerEmailNotifications"] = "managerEmailNotifications";
    CompanyEnabledFeatureKeyType["employeeEmailNotifications"] = "employeeEmailNotifications";
    CompanyEnabledFeatureKeyType["allowEmployeesDisableEmailNotifications"] = "allowEmployeesDisableEmailNotifications";
})(CompanyEnabledFeatureKeyType || (CompanyEnabledFeatureKeyType = {}));
export var RoleType;
(function (RoleType) {
    RoleType["Basic"] = "Basic";
    RoleType["Manager"] = "Manager";
    RoleType["Admin"] = "Admin";
    RoleType["BenefitAdmin"] = "BenefitAdmin";
    RoleType["RootAdmin"] = "RootAdmin";
    RoleType["Supervisor"] = "Supervisor";
    RoleType["CompanyCreator"] = "CompanyCreator";
    RoleType["AdminSupervisor"] = "AdminSupervisor";
})(RoleType || (RoleType = {}));
export var SocialNetwork;
(function (SocialNetwork) {
    SocialNetwork["Vkontakte"] = "Vkontakte";
    SocialNetwork["Instagram"] = "Instagram";
    SocialNetwork["Facebook"] = "Facebook";
    SocialNetwork["Telegram"] = "Telegram";
    SocialNetwork["LinkedIn"] = "LinkedIn";
    SocialNetwork["X"] = "X";
    SocialNetwork["Slack"] = "Slack";
})(SocialNetwork || (SocialNetwork = {}));
export var FeedbackSectionType;
(function (FeedbackSectionType) {
    FeedbackSectionType["ProductOrders"] = "0";
    FeedbackSectionType["Activities"] = "1";
    FeedbackSectionType["OneToOnes"] = "2";
    FeedbackSectionType["Surveys"] = "3";
    FeedbackSectionType["SupportRequests"] = "4";
})(FeedbackSectionType || (FeedbackSectionType = {}));
export var FeedbackTriggerType;
(function (FeedbackTriggerType) {
    FeedbackTriggerType["ProductOrdered"] = "0";
    FeedbackTriggerType["TealRequestCreated"] = "1";
    FeedbackTriggerType["ActivityCreated"] = "2";
    FeedbackTriggerType["ActivityUpdated"] = "3";
    FeedbackTriggerType["CurrencyAccrues"] = "4";
    FeedbackTriggerType["OneToOneCommentCreated"] = "5";
    FeedbackTriggerType["OneToOneCreated"] = "6";
    FeedbackTriggerType["OneToOneUpdated"] = "7";
    FeedbackTriggerType["SurveyCompleted"] = "8";
    FeedbackTriggerType["SurveyCreated"] = "9";
    FeedbackTriggerType["SurveyUpdated"] = "10";
    FeedbackTriggerType["SupportRequestCreated"] = "11";
    FeedbackTriggerType["SupportRequestResolved"] = "12";
})(FeedbackTriggerType || (FeedbackTriggerType = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Mobile"] = "Mobile";
    DeviceType["Web"] = "Web";
})(DeviceType || (DeviceType = {}));
